import { z } from 'zod';
import { localeSchema } from './common.js';

export const waitlistEntrySchema = z.object({
  email: z.string().email().toLowerCase(),
  name: z.string().min(1).max(120).optional(),
  country: z.string().length(2).optional(),
  locale: localeSchema.default('es'),
  utm: z
    .object({
      source: z.string().max(120).optional(),
      medium: z.string().max(120).optional(),
      campaign: z.string().max(120).optional(),
    })
    .partial()
    .optional(),
});
export type WaitlistEntry = z.infer<typeof waitlistEntrySchema>;
